export const GET_ACCOUNT_DELETION_REQUESTS = 'GET_ACCOUNT_DELETION_REQUESTS';

export function accountDeletionRequestList(data, callback) {
  return {
    type: GET_ACCOUNT_DELETION_REQUESTS,
    payload: {data, callback},
  }; 
}